// hooks/useWebOtp.ts
import { useEffect } from 'react';

export const useWebOtp = (onOtpReceived: (otp: string) => void) => {
    useEffect(() => {
        if ('OTPCredential' in window && 'credentials' in navigator) {
            const abort = new AbortController();

            (async () => {
                try {
                    const content = await (navigator as any).credentials.get({
                        otp: { transport: ['sms'] },
                        signal: abort.signal,
                    });
                    if (content?.code) {
                        onOtpReceived(content.code);
                    }
                } catch (err) {
                    console.warn('Web OTP API failed or user denied:', err);
                }
            })();

            return () => abort.abort();
        }
    }, [onOtpReceived]);
};
